<template>
  <MasterLayout>
    <!-- <div class="section__row mt-3" style="margin-bottom: 216px"> -->
    <div class="pt-5 pb-3 pl-4 pr-3 dashboard_first_row" id="cuscus">
      <div>
        <b-modal
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.iFundWallet.confirmingPayment')"
          v-if="status == loading"
        >
          <div
            class="epump-loader"
            style="top: 22%; left: 35%; width: 120px; height: 120px"
          >
            <img src="@/assets/img/epump-logo.png" class="epump-loader-logo" />
          </div>
        </b-modal>
        <b-modal
          v-if="status == success"
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.iFundWallet.paymentConfirmed')"
        >
          <div style="margin: 0 auto; width: 43%; margin-top: 80px" class>
            <div class="success-checkmark">
              <div class="check-icon">
                <span class="icon-line line-tip"></span>
                <span class="icon-line line-long"></span>
                <div class="icon-circle"></div>
                <div class="icon-fix"></div>
              </div>
            </div>
          </div>
        </b-modal>
        <b-modal
          v-if="status == failure"
          ref="my-modal"
          id="modal1"
          hide-footer
          :title="$t('text.iFundWallet.errorConfirmingStripe')"
        >
          <div style="margin: 0 auto; width: 43%">
            <svg
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 130.2 130.2"
              class="cancel_img"
            >
              <circle
                class="path circle"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-miterlimit="10"
                cx="65.1"
                cy="65.1"
                r="62.1"
              />
              <line
                class="path line"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="34.4"
                y1="37.9"
                x2="95.8"
                y2="92.3"
              />
              <line
                class="path line"
                fill="none"
                stroke="#D06079"
                stroke-width="6"
                stroke-linecap="round"
                stroke-miterlimit="10"
                x1="95.8"
                y1="38"
                x2="34.4"
                y2="92.2"
              />
            </svg>
            <div class="mt-3">
              <router-link
                :to="{
                  name: 'company_wallet',
                  query: {
                    companyId: this.companyId,
                  },
                }"
              >
                <button
                  class="add__new__retainership_btn"
                  style="border-radius: 6px; background-color: green"
                >
                  {{ $t("text.cMasterLayout.wallet") }}
                </button>
              </router-link>
            </div>
          </div>
        </b-modal>
      </div>
      <!-- <div class="text-center pb-4">
        <p class="page-header">{{ $t("text.iFundWallet.makePayment") }}</p>
      </div> -->
      <!-- <div class="center_div pb-5" style="margin-top: 0px"> -->

      <div class="justify-content-center align-items-center g-2 mb-4">
        <div style="width: 50%; margin: auto">
          <div v-show="btnDynamic == false">
            <input
              @input="rmvDis"
              type="number"
              name="amount"
              v-model="amount"
              class="form-control form__input amount mt-5"
              :placeholder="$t('text.iFundWallet.inputUSD')"
              style="width: 70%; margin: auto"
            />
            <p class="text-right" style="width: 85%">
              <span class="text-muted" style="font-size: 10px"
                >{{ $t("text.iFundWallet.poweredBy") }}
                <i
                  class="mr-1 fa fa-cc-stripe"
                  style="font-size: 15px; color: #635bff"
                  aria-hidden="true"
                  v-b-tooltip.hover
                ></i
              ></span>
            </p>
          </div>
          <button
            id="nextBtnn"
            v-show="btnDynamic == false"
            class="ep-btn ep-primary mt-4"
            style="width: 30%; margin: auto"
            @click="next($event)"
            disabled
          >
            <span>{{ $t("text.iAddOrder.next") }}</span>
          </button>
        </div>

        <div v-show="amount !== '' && btnDynamic == true" class="">
          <div class="row">
            <div class="col"></div>
            <div class="col pay_header text-center">
              {{ $t("text.iFundWallet.fundAccountWithCard") }}
            </div>
            <div v-if="btnDynamic == true" class="col">
              <i
                class="ml-5 cursor-pointer fa fa-times-circle-o"
                style="font-size: 30px; color: #ee0000"
                aria-hidden="true"
                v-b-tooltip.hover
                :title="$t('text.linkBankAccModal.back')"
                @click="back"
              ></i>
            </div>
          </div>

          <!-- stripe integration -->

          <div class="mt-4" style="width: 45%; margin: auto">
            <div class="row p-3">
              <div class="col">
                <img src="@/assets/img/epump-logo.png" width="50px" />
              </div>
              <div v-if="btnDynamic == true" class="col text-right">
                <p class="text-right">
                  <span class="text-muted" style="font-size: 30px"
                    >${{ convertThousand(Number(amount)) }}</span
                  >
                  <br />
                  <span class="text-muted" style="font-size: 12px; margin: 0">
                    {{ $t("text.iFundWallet.poweredBy") }}
                    <i
                      class="mr-1 fa fa-cc-stripe"
                      style="font-size: 15px; color: #635bff"
                      aria-hidden="true"
                      v-b-tooltip.hover
                    ></i
                  ></span>
                </p>
              </div>
            </div>
            <hr class="mb-3" />

            <form id="payment-form">
              <div id="link-authentication-element">
                <!--Stripe.js injects the Link Authentication Element-->
              </div>
              <div id="payment-element">
                <!--Stripe.js injects the Payment Element-->
              </div>
              <button
                class="ep-btn ep-primary"
                id="submit"
                @click="handleSubmit($event)"
              >
                <div class="spinner hidden" id="spinner"></div>
                <span id="button-text">{{
                  $t("text.iFundWallet.payNow")
                }}</span>
              </button>
              <div id="payment-message" class="hidden"></div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </MasterLayout>
</template>

<script>
import Vue from "vue";
import MasterLayout from "@/views/Company/MasterLayout.vue";
import configObject from "@/config";
import cardBackgroundUrl from "@/assets/img/Group393.svg";
import backgroundUrl from "@/assets/img/MobileWallet.png";
import TableLoader from "@/components/tableLoader/index";
import backImg from "@/assets/img/pattern_img.png";
import {
  Page,
  Sort,
  Toolbar,
  Search,
  ExcelExport,
  PdfExport,
} from "@syncfusion/ej2-vue-grids";
import JQuery from "jquery";
let $ = JQuery;

export default {
  title: "Make Payment:: Epump Portal",
  name: "MakePayment",
  components: {
    MasterLayout,
    TableLoader,
  },
  provide: {
    grid: [Page, Sort, Toolbar, Search, ExcelExport, PdfExport],
  },
  data() {
    return {
      backImg,
      tab: "wallet",
      loading: 0,
      paymentConfirmed: null,
      success: 1,
      failure: 2,
      status: 0,
      backgroundUrl,
      modalWidth: null,
      modalheight: null,
      showBanner: true,
      payOnline: true,
      email: "",
      phone: "",
      publicKey: "",
      banks: null,
      amount: "",
      depositNo: null,
      depositorName: null,
      bank: null,
      showdropDown: false,
      accountNumber: null,
      toggleBanksDropdown: false,
      isButtonDisabled: false,
      showButtonLoader: true,
      flwRef: "",
      trxRef: "",
      reservedAccount: null,
      accountName: null,
      accountNumber: null,
      bankName: null,
      company: null,
      companyId: null,
      invoiceId: null,
      fundingAmount: null,
      depositorName: null,
      amountPaid: 0,
      depositorName: "",
      abankName: "selectAccount",
      referralCode: "",
      depositSlipNo: "",
      datePaid: this.$moment().format("YYYY-MM-DDTHH:mm:ss"),
      maxDate: this.$moment(new Date()).format("YYYY-MM-DD"),
      walletBalance: 0,
      displayAmt: false,
      displayTxt: false,
      stripePkey: "",
      clientSecret: "",
      stripe: {},
      emailAddress: "",
      elements: {},
      btnDynamic: false,

      // stripe: Stripe(this.stripePkey),
    };
  },
  created() {
    this.$eventHub.$on("company", (company) => {
      this.company = company;
      this.companyId = this.$route.query.companyId
        ? this.$route.query.companyId
        : this.company.id;
      this.invoiceId = this.$route.query.id;
      // this.getFundProperties();
      // this.getAccountDetails();
      // this.getWalletBalance();
      // this.getStripePKey();
      // this.duo();
    });
  },
  beforeDestroy() {},
  mounted() {
    if (this.$route.query.payment_intent_client_secret) {
      this.clientSecret = this.$route.query.payment_intent_client_secret;
      document.getElementById("cuscus").style.cursor = "wait";
      this.duo();
    }
  },
  watch: {
    company(company) {
      if (company !== null) {
        // this.getFundProperties();
        // this.getAccountDetails();
        this.getStripePKey();
        // this.duo();
      }
    },
  },
  methods: {
    rmvDis() {
      // console.log("inputting number");
      if (this.amount !== "") {
        // console.log("tracking");
        document.querySelector("#nextBtnn").removeAttribute("disabled");
      } else {
        document.querySelector("#nextBtnn").setAttribute("disabled", "");
      }
    },
    next() {
      this.btnDynamic = !this.btnDynamic;
      // this.duo();
      this.initialize();
      // this.checkStatus();
    },
    back() {
      this.btnDynamic = !this.btnDynamic;
      // document.querySelector("#nextBtnn").removeAttribute("disabled");
    },
    // changeTab(tab) {
    //   this.tab = tab;
    // },
    // maked() {
    //   this.$router.push("/Industrial/Branch/Dashboard");
    // },
    randomString(length, chars) {
      var result = "";
      for (var i = length; i > 0; --i)
        result += chars[Math.floor(Math.random() * chars.length)];
      return result;
    },
    generateTransactionRef() {
      var allString = "0123456789";
      var rString = "EP" + this.randomString(14, allString);
      return rString;
    },
    // STRIPE INTEGRATION STARTS
    duo() {
      this.getStripePKey().then((result) => {
        this.checkStatus();
      });
    },
    getStripePKey() {
      return this.axios
        .get(
          `${configObject.apiBaseUrl}/stripe/stripepublishingkey`,
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response.data.secretKey);
          this.stripePkey = response.data.secretKey;
          this.stripe = Stripe(response.data.secretKey);
          // console.log(this.stripe);
        })
        .catch((error) => {});
    },
    initialize() {
      this.axios
        .post(
          `${configObject.apiBaseUrl}/stripe/createpaymentintent`,
          { Amount: this.amount },
          configObject.authConfig()
        )
        .then((response) => {
          // console.log(response.data.clientSecret);
          // this.clientSecret = response.data.clientSecret;
          // console.log(response.data);
          this.clientSecret = response.data.clientSecret;

          const clientSecret = this.clientSecret;

          const appearance = {
            theme: "stripe",
          };
          // let clientSecret;
          // console.log(clientSecret);
          let elements;
          this.elements = this.stripe.elements({ appearance, clientSecret });
          elements = this.elements;
          // console.log(elements);

          const linkAuthenticationElement =
            elements.create("linkAuthentication");
          linkAuthenticationElement.mount("#link-authentication-element");

          linkAuthenticationElement.on("change", (event) => {
            this.emailAddress = event.value.email;
          });

          const paymentElementOptions = {
            layout: "tabs",
          };

          const paymentElement = elements.create(
            "payment",
            paymentElementOptions
          );
          paymentElement.mount("#payment-element");
        })
        .catch((error) => {
          this.$toast.open({
            message: this.$t("text.errors.errorOccured"),
            type: "error",
            duration: 5000,
          });
        });
    },
    async handleSubmit($event) {
      $event.preventDefault();
      this.setLoading(true);
      let elements;
      elements = this.elements;
      let emailAddress;
      emailAddress = this.emailAddress;
      // console.log("about to confirm");

      const { error } = await this.stripe.confirmPayment({
        elements,
        confirmParams: {
          // Make sure to change this to your payment completion page
          return_url: window.location.href,
          // return_url:
          //   "http://localhost:8080/Company/make-stripe-payment?companyId=9e5f6ff4-81de-43cc-aa44-93798080875e",
          receipt_email: emailAddress,
        },
      });
      // console.log(error);

      // This point will only be reached if there is an immediate error when
      // confirming the payment. Otherwise, your customer will be redirected to
      // your `return_url`. For some payment methods like iDEAL, your customer will
      // be redirected to an intermediate site first to authorize the payment, then
      // redirected to the `return_url`.
      if (error.type === "card_error" || error.type === "validation_error") {
        this.showMessage(error.message);
      } else {
        this.$toast.open({
          message: this.$t("text.omit.unexpectedError"),
          type: "success",
          duration: 3000,
        });
        this.showMessage(this.$t("text.omit.unexpectedError"));
      }

      this.setLoading(false);
    },

    // Fetches the payment intent status after payment submission
    async checkStatus() {
      // console.log("checking statussss");
      const clientSecret = new URLSearchParams(window.location.search).get(
        "payment_intent_client_secret"
      );

      if (!clientSecret) {
        return;
      }

      const { paymentIntent } = await this.stripe.retrievePaymentIntent(
        clientSecret
      );

      switch (paymentIntent.status) {
        case "succeeded":
          // console.log("Payment succeeded!");
          // console.log(paymentIntent.amount);
          this.amount = paymentIntent.amount;
          this.$toast.open({
            message: this.$t("text.omit.paymentSucceeded"),
            type: "success",
            duration: 3000,
          });
          this.showMessage(
            this.$t("text.omit.paymentSucceeded") + paymentIntent.amount
          );
          this.status = this.loading;
          this.showModal();
          this.confirmPayment();
          break;
        case "processing":
          // console.log("Payment processing!");
          this.$toast.open({
            message: this.$t("text.omit.paymentProcessing"),
            type: "success",
            duration: 3000,
          });
          this.showMessage(this.$t("text.omit.paymentProcessing"));
          break;
        case "requires_payment_method":
          // console.log("Your payment was not successful, please try again.");
          this.$toast.open({
            message: this.$t("text.omit.paymentNotSuccessful"),
            type: "error",
            duration: 3000,
          });
          this.showMessage(this.$t("text.omit.paymentNotSuccessful"));
          break;
        default:
          // console.log("Something went wrong.");
          this.$toast.open({
            message: this.$t("text.omit.SomethingWentWrong"),
            type: "error",
            duration: 3000,
          });
          this.showMessage(this.$t("text.omit.SomethingWentWrong"));
          break;
      }
    },
    // ------- UI helpers -------

    showMessage(messageText) {
      const messageContainer = document.querySelector("#payment-message");
      this.$toast.open({
        message: messageText,
        type: "error",
        duration: 4000,
      });

      messageContainer.classList.remove("hidden");
      messageContainer.textContent = messageText;

      setTimeout(function () {
        messageContainer.classList.add("hidden");
        messageText.textContent = "";
      }, 4000);
    },

    // Show a spinner on payment submission
    setLoading(isLoading) {
      if (isLoading) {
        // Disable the button and show a spinner
        document.querySelector("#submit").disabled = true;
        document.querySelector("#spinner").classList.remove("hidden");
        document.querySelector("#button-text").classList.add("hidden");
      } else {
        document.querySelector("#submit").disabled = false;
        document.querySelector("#spinner").classList.add("hidden");
        document.querySelector("#button-text").classList.remove("hidden");
      }
    },
    // STRIPE INTEGRATION ENDS

    // TO SETTLE INVOICE DIRECTLY IF YOU'RE COMING FROM INVOICE PAGE
    directInvoiceSettlement() {
      const data = {
        invoiceId: this.$route.query.id,
        amountPaid: this.$route.query.amt,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Invoices/settle-invoice-payment`,
          data,
          configObject.authConfig()
        )
        .then((response) => {
          this.$toast.open({
            message: this.$t("text.invoicesModal.paymentSuccessful"),
            type: "success",
            duration: 3000,
          });
          this.$router.push({
            name: "invoice_details",
            query: { id: this.invoiceId, companyId: this.companyId },
          });
        })
        .catch((error) => {
          $(".loader").hide();
          this.$toast.open({
            message: error.response.data.message,
            type: "error",
            duration: 3000,
          });
        });
    },
    convertThousand(request) {
      if (!isFinite(request)) {
        return "0.00";
      }
      return request
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    showModal() {
      this.$refs["my-modal"].show();
    },
    hideModal() {
      this.$refs["my-modal"].hide();
    },
    confirmPayment() {
      let data = {
        companyId: this.companyId,
        amount: parseFloat(this.amount),
        flw: false,
        stripe: true,
        paymentIntentId: this.$route.query.payment_intent,
      };
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Wallet/FundWalletOnline`,
          data,
          configObject.authConfig()
        )
        .then(() => {
          this.status = this.success;
          this.showModal();
          this.$toast.open({
            message: this.$t("text.iFundWallet.paymentConfirmed"),
            type: "success",
            duration: 5000,
          });
          if (
            this.$route.query.id &&
            this.$route.query.amt &&
            parseFloat(this.amount) >= this.$route.query.amt
          ) {
            // console.log("settling direct invoice");
            this.directInvoiceSettlement();
          } else {
            setTimeout(this.routeToComWallet, 3000);
          }
        })
        .catch((error) => {
          // console.log(error);
          this.status = this.failure;
          // this.$toast.open({
          //   message: error,
          //   type: "success",
          //   duration: 5000,
          // });
        });
    },
    routeToComWallet() {
      this.$router.push({
        name: "company_wallet",
        query: { companyId: this.companyId },
      });
    },
  },
};
</script>

<style scoped>
form {
  width: 30vw;
  min-width: 500px;
  align-self: center;
  box-shadow: 0px 0px 0px 0.5px rgba(50, 50, 93, 0.1),
    0px 2px 5px 0px rgba(50, 50, 93, 0.1), 0px 1px 1.5px 0px rgba(0, 0, 0, 0.07);
  border-radius: 7px;
  padding: 40px;
}

.hidden {
  display: none;
}

#payment-message {
  color: rgb(105, 115, 134);
  font-size: 16px;
  line-height: 20px;
  padding-top: 12px;
  text-align: center;
}

#payment-element {
  margin-bottom: 24px;
}

/* Buttons and links */
button {
  background: #5469d4;
  font-family: Arial, sans-serif;
  color: #ffffff;
  border-radius: 4px;
  border: 0;
  padding: 12px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  display: block;
  transition: all 0.2s ease;
  box-shadow: 0px 4px 5.5px 0px rgba(0, 0, 0, 0.07);
  width: 100%;
}
button:hover {
  filter: contrast(115%);
}
button:disabled {
  opacity: 0.5;
  cursor: default;
}

/* spinner/processing state, errors */
.spinner,
.spinner:before,
.spinner:after {
  border-radius: 50%;
}
.spinner {
  color: #ffffff;
  font-size: 22px;
  text-indent: -99999px;
  margin: 0px auto;
  position: relative;
  width: 20px;
  height: 20px;
  box-shadow: inset 0 0 0 2px;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
}
.spinner:before,
.spinner:after {
  position: absolute;
  content: "";
}
.spinner:before {
  width: 10.4px;
  height: 20.4px;
  background: #5469d4;
  border-radius: 20.4px 0 0 20.4px;
  top: -0.2px;
  left: -0.2px;
  -webkit-transform-origin: 10.4px 10.2px;
  transform-origin: 10.4px 10.2px;
  -webkit-animation: loading 2s infinite ease 1.5s;
  animation: loading 2s infinite ease 1.5s;
}
.spinner:after {
  width: 10.4px;
  height: 10.2px;
  background: #5469d4;
  border-radius: 0 10.2px 10.2px 0;
  top: -0.1px;
  left: 10.2px;
  -webkit-transform-origin: 0px 10.2px;
  transform-origin: 0px 10.2px;
  -webkit-animation: loading 2s infinite ease;
  animation: loading 2s infinite ease;
}

@-webkit-keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}
@keyframes loading {
  0% {
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@media only screen and (max-width: 600px) {
  form {
    width: 80vw;
    min-width: initial;
  }
}
</style>
